import { render } from "./baseModalLace.vue?vue&type=template&id=5637401c&scoped=true"
import script from "./baseModalLace.vue?vue&type=script&lang=js"
export * from "./baseModalLace.vue?vue&type=script&lang=js"

import "./baseModalLace.vue?vue&type=style&index=0&id=5637401c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5637401c"]])

export default __exports__